import { render, staticRenderFns } from "./DivisionForm.vue?vue&type=template&id=8287f3a8&"
import script from "./DivisionForm.vue?vue&type=script&lang=js&"
export * from "./DivisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports